import { bgColorsVars } from '@design-system/vars.css';
import { MenuItem, Select, Tooltip } from '@mui/material';
import { Control, Controller, Path } from 'react-hook-form';

export const RHFSelect = <T extends object>({
  control,
  name,
  options,
  hasError,
  tooltipText,
  required,
  disabled,
}: {
  control: Control<T, any, T>;
  name: Path<T>;
  options: Array<Record<string, string | number | null>>;
  hasError?: boolean;
  tooltipText?: Record<number, string>;
  required?: boolean;
  disabled?: boolean;
}) => (
  <Controller
    name={name}
    control={control}
    render={({ field }) => (
      <Select
        id={`select-${name}`}
        {...field}
        error={hasError}
        required={!!required}
        displayEmpty={true}
        renderValue={(value: string | number | null) =>
          field.value
            ? options.find((i) => i.value === field.value)?.label
            : 'Select'
        }
        className="shadow-none border-2 rounded-[10px] px-4 py-2"
        disabled={disabled}
      >
        {options.map((option) => (
          <MenuItem
            key={option.label}
            value={option.value}
            id={`select-${option.value}`}
          >
            <Tooltip
              title={tooltipText?.[option.value as number] || ''}
              key={option.name}
              placement="right"
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: bgColorsVars['N-40'],
                    color: 'black',
                    fontSize: '14px',
                    fontWeight: 500,
                    fontFamily: 'inherit',
                    padding: '4px 8px',
                  },
                },
              }}
            >
              <div>{option.label}</div>
            </Tooltip>
          </MenuItem>
        ))}
      </Select>
    )}
  />
);
